import * as React from "react";
import { useContext, useState, useEffect, useMemo } from "react";
import {
  DataGrid,
  GridCellEditCommitParams,
  GridColDef,
  GridColumnVisibilityModel,
  GridRenderCellParams,
  GridRowId,
  GridSelectionModel,
  MuiBaseEvent,
  MuiEvent,
} from "@mui/x-data-grid";
import { useLocation } from "react-router-dom";
import PageHelper from "../../helper/pageHelper";
import "react-confirm-alert/src/react-confirm-alert.css";
import IconButton from "@mui/material/IconButton";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import ReplayIcon from "@mui/icons-material/Replay";
import SaveIcon from "@mui/icons-material/Save";
import WarningIcon from "@mui/icons-material/Warning";
import {
  Alert,
  Box,
  Button,
  FormControl,
  MenuItem,
  Select,
  Snackbar,
  Stack,
  Step,
  StepLabel,
  Stepper,
  Tooltip,
  Typography,
} from "@mui/material";
import TopoProdutoAcabado from "./topo";
import ProdutoAcabadoDataSet from "../../components/data/ProdutoAcabadoDataSet";
import ProdutoAcabado from "../../components/classes/ProdutoAcabado";
import AutocompleteCentroProdutoAcabado from "../../components/common/AutocompleteCentroProdutoAcabado";
import CentroDataset from "../../components/data/CentroDataset";
import CentroDistribuicao from "../../components/classes/CentroDistribuicao";
import { confirmAlert } from "react-confirm-alert";
import Contrato from "../../components/classes/Contrato";
import PropriedadeParceiroDataset from "../../components/data/PropriedadeParceiroDataSet";
import PropriedadeParceiro from "../../components/classes/PropriedadeParceiro";
import { Send } from "@mui/icons-material";
import SkuDescricao from "../../components/common/SkuDescricao";
import { UserContext } from "../../App";
import Utils from "../../helper/utils";
import { produce } from "immer";
import styles from "./detail.module.css";
import { Data, enumData, LoadGroup } from "./types";
import ContratoItemDataSet from "../../components/data/ContratoItemDataSet";
import ContratoItemOrigem from "../../components/classes/ContratoItemOrigem";
import CustomAlertStep1 from "./customAlertStep1";
import CustomAlertStep2 from "./customAlertStep2";

import { useTranslation } from "react-i18next";

export default function ProdutoAcabadoPage() {
  const { t } = useTranslation();

  const steps = [
    t("pages.finishiedProduct.text.availableProductsList"),
    t("pages.finishiedProduct.text.prioritizeDeliveries"),
    t("pages.finishiedProduct.text.generatePreOrder"),
    t("pages.finishiedProduct.text.productsAlreadyRequested"),
  ];

  const user: any = useContext(UserContext);
  const [open, setOpen] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [showInconsistenceWarning, setShowInconsistenteWarning] =
    useState(false);
  const [showApproveModal, setShowApproveModal] = useState(false);

  const codigoFornecedorSap = Number(
    localStorage.getItem("CodigoFornecedorSAPSelecionado")
  );

  const contratoSelecionadoCache = String(
    localStorage.getItem("ContratoSelecionado")
  );

  const numeroContrato: string = useMemo(() => {
    let numeroContrato: string = "";
    if (contratoSelecionadoCache) {
      const contratoSelecionado: Contrato = JSON.parse(
        contratoSelecionadoCache
      );
      numeroContrato = contratoSelecionado?.numeroContrato as string;
    }
    return numeroContrato;
  }, [contratoSelecionadoCache]);

  const parceiroSelecionadoCache = String(
    localStorage.getItem("PropriedadeParceiroCache")
  );

  const paletizacaoMinima: number = useMemo(() => {
    let paletizacao: number = 0;
    if (parceiroSelecionadoCache && parceiroSelecionadoCache !== "undefined") {
      const parceiroSelecionado: PropriedadeParceiro[] = JSON.parse(
        parceiroSelecionadoCache
      );
      const paletizacaoTemp = parceiroSelecionado
        ? parceiroSelecionado.find((f) => f.chave === "PALETIZACAO MINIMA (KG)")
            ?.valor
        : 0;
      if (paletizacaoTemp) {
        paletizacao = Number(paletizacaoTemp);
      }
    }
    return paletizacao;
  }, [parceiroSelecionadoCache]);

  const paletizacaoMaxima = 800;

  const bloqueiaSaldoNegativo: boolean = useMemo(() => {
    let bloqueio = false;

    if (parceiroSelecionadoCache && parceiroSelecionadoCache !== "undefined") {
      const propriedades: PropriedadeParceiro[] = JSON.parse(
        parceiroSelecionadoCache
      );
      const propriedade = propriedades.find(
        (f) => f.chave === "BLOQUEIA PEDIDO SEM SALDO"
      );
      if (propriedade) {
        bloqueio = propriedade.valor === "S";
      }
    }

    return bloqueio;
  }, [parceiroSelecionadoCache]);

  const [produtosAcabados, setProdutosAcabados] = useState<ProdutoAcabado[]>(
    []
  );

  const [idsSelecionados, setIdsSelecionados] = useState<GridRowId[]>([]);

  const hasIdSelecionado: boolean = useMemo(
    () => idsSelecionados && idsSelecionados.length > 0,
    [idsSelecionados]
  );

  const dataSet: ProdutoAcabadoDataSet = new ProdutoAcabadoDataSet();
  const dataSetCentro: CentroDataset = new CentroDataset();
  const dataSetParceiro: PropriedadeParceiroDataset =
    new PropriedadeParceiroDataset();
  const contratoItemDataSet: ContratoItemDataSet = new ContratoItemDataSet();

  const [sizePage, setSizePage] = useState(50);
  const [habilita, setHabilita] = useState(false);
  const [loading, setLoading] = useState(false);
  //const [columns, setColumns] = useState<GridColDef[]>([]);
  const [rows, setRows] = useState<Data[]>([]);
  const [origens, setOrigens] = useState<ContratoItemOrigem[]>([]);
  const [origem, setOrigem] = useState<string>("222");
  const [datCarregamento, setDatCarregamento] = useState<Date>(new Date());
  const [datPrevistaEntrega, setDatPrevistaEntrega] = useState<Date>(
    new Date()
  );
  const [centroDestino, setCentroDestino] = useState<number>();
  const [depositoDestino, setDepositoDestino] = useState<string>("");

  const [loadGroup, setLoadGroup] = useState({} as LoadGroup);

  const [idLinhaSelecionada, setIdLinhaSelecionada] = useState<number>(0);

  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({});

  useEffect(() => {
    Utils.setDocumentTitle(
      numeroContrato
        ? numeroContrato.valueOf()
        : t("pages.finishiedProduct.text.withoutContract"),
      `| Step ${step} - ${t("pages.finishiedProduct.text.finishiedProduct")}`
    );
    setLoading(true);
    localStorage.setItem("SkuAcabados", [] as any);
    if (codigoFornecedorSap > 0 && produtosAcabados.length === 0) {
      dataSet
        .ListarAtivosPorContratoStep(codigoFornecedorSap, numeroContrato, step)
        .then((result) => {
          setProdutosAcabados(result);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    var produtoAcabado = produtosAcabados.find(
      (y: any) => y.id == idLinhaSelecionada
    );
    if (!produtoAcabado) return;

    contratoItemDataSet
      .ListarOrigensDoSku(
        +produtoAcabado.idSku,
        produtoAcabado.contrato.toString(),
        produtoAcabado?.projeto
      )
      .then((origens: ContratoItemOrigem[]) => {
        setOrigem("");
        setOrigens(origens);
      });
  }, [idLinhaSelecionada]);

  const renderEditCell = () => {
    return (
      <FormControl fullWidth>
        <Select
          labelId="selectorigemitem"
          id="selectorigemitem"
          label={t("common.origin")}
          value={origem}
          onChange={(e) => setOrigem(e.target.value)}
        >
          {origens.map((origem: ContratoItemOrigem) => (
            <MenuItem key={origem.id} value={origem.origem}>
              {origem.origem}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  };

  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  let query = useQuery();
  let _step: number =
    query.get("step")?.valueOf() === undefined
      ? 1
      : Number(query.get("step")?.valueOf());
  let step: number = _step > 0 && _step < 5 ? _step : 4;

  // const handlerDataCarregamentoChange = async (params: any, value: string) => {
  //   const newDate: Date = new Date(value);

  //   setRows(prev => produce(prev, draft => {
  //     const row_ = draft.find(line => line.id === params.id);
  //     if (row_) {
  //       if (row_[enumData.dataCarregamento] !== newDate) {
  //         row_[enumData.dataCarregamento] = newDate;
  //       }
  //     }
  //   }))
  // };

  // const handlerDataSolicitadaChange = async (params: any, value: string) => {
  //   const newDate: Date = new Date(value);

  //   setRows(prev => produce(prev, draft => {
  //     const row_ = draft.find(line => line.id === params.id);
  //     if (row_) {
  //       if (row_[enumData.dataEntrega] !== newDate) {
  //         row_[enumData.dataEntrega] = newDate;
  //       }
  //     }
  //   }))
  // };

  /* Data Grid */
  const getColumns = () => {
    let cols: GridColDef[] = [];
    if (step === 1) {
      cols = [
        {
          field: "id",
          headerName: t("common.id"),
          width: 50,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "criadoEm",
          headerName: t("common.createdAt"),
          width: 100,
          editable: false,
          align: "center",
          headerAlign: "center",
          valueFormatter: (params: any) => {
            return params.value ? dateFormat(params.value) : "";
          },
        },
        {
          field: "skuDescricao",
          headerName: t("common.skuIdDelivery"),
          minWidth: 300,
          flex: 2,
          editable: false,
          align: "center",
          headerAlign: "center",
          renderCell: (params: any) => <SkuDescricao value={params.value} />,
        },
        {
          field: "origem",
          headerName: t("common.origin"),
          minWidth: 100,
          flex: 1,
          align: "center",
          headerAlign: "center",
          editable: true,
          renderEditCell: renderEditCell,
        },
        {
          field: "quantidadeDePaletes",
          headerName: t("common.palletizing"),
          width: 120,
          editable: true,
          align: "center",
          headerAlign: "center",
          type: "number",
          valueFormatter: (params: any) => round3(params.value),
        },
        {
          field: "quantidadeEntregue",
          headerName: t("common.quantity"),
          width: 120,
          editable: false,
          align: "center",
          headerAlign: "center",
          type: "number",
          valueFormatter: (params: any) => round3(params.value) + " Kg",
        },
        // ,
        // {
        //   field: "saldo",
        //   headerName: "Saldo",
        //   width: 120,
        //   editable: false,
        //   align: "center",
        //   headerAlign: "center",
        //   type: "number",
        //   renderCell: (params: any) => {
        //     return (
        //       <div className={styles.warning}>
        //         {`${round3(params.value)} Kg`}
        //         {params.value < params.row.quantidadeEntregue && (
        //           <Tooltip title={<p>Quantidade informada excedeu o saldo.</p>}>
        //             <WarningIcon htmlColor={'rgba(0, 0, 0, 0.54)'} />
        //           </Tooltip>
        //         )}
        //       </div>
        //     )
        //   }
        // }
      ];
    } else if (step === 2) {
      cols = [
        {
          field: "id",
          headerName: t("common.id"),
          width: 50,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "criadoEm",
          headerName: t("common.createdAt"),
          width: 100,
          editable: false,
          align: "center",
          headerAlign: "center",
          valueFormatter: (params) => {
            return params.value ? dateFormat(params.value) : "";
          },
        },
        {
          field: "dataEntrega",
          headerName: t("common.loadingDate"),
          width: 200,
          editable: false,
          align: "center",
          headerAlign: "center",
          renderCell: (params: GridRenderCellParams) => {
            return (
              <div className="MuiDataGrid-cellContent">
                {params.value ? dateFormat(params.value) : ""}
              </div>
            );
          },
        },
        {
          field: "skuDescricao",
          headerName: t("common.skuIdDelivery"),
          minWidth: 300,
          flex: 2,
          editable: false,
          align: "center",
          headerAlign: "center",
          renderCell: (params) => <SkuDescricao value={params.value} />,
        },
        {
          field: "quantidadeEntregue",
          headerName: t("common.quantity"),
          width: 120,
          editable: false,
          align: "center",
          headerAlign: "center",
          type: "number",
          valueFormatter: (params) => round3(params.value) + " Kg",
        },
        {
          field: "paletizacao",
          headerName: t("common.palletizing"),
          width: 120,
          editable: false,
          align: "center",
          headerAlign: "center",
          type: "number",
          valueFormatter: (params) => round3(params.value),
        },
        {
          field: "grupoAmarracao",
          headerName: t("common.loading"),
          align: "center",
          headerAlign: "center",
          width: 150,
          editable: false,
          valueFormatter: (params) =>
            params.value ? `G - ${params.value}` : "",
        },
        {
          field: "origem",
          headerName: t("common.origin"),
          minWidth: 100,
          flex: 1,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "centroOrigem",
          headerName: t("common.originCenter"),
          width: 150,
          editable: step === 2,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "centroOrigemDescricaoLabel",
          headerName: t("common.originCenter"),
          width: 200,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "depositoOrigem",
          headerName: t("common.originDeposit"),
          width: 150,
          editable: step === 2,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "contratoSap",
          headerName: t("common.contractSap"),
          width: 150,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
      ];
    } else {
      cols = [
        {
          field: "id",
          headerName: t("common.id"),
          width: 50,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "criadoEm",
          headerName: t("common.createdAt"),
          width: 100,
          editable: false,
          align: "center",
          headerAlign: "center",
          valueFormatter: (params) => {
            return params.value ? dateFormat(params.value) : "";
          },
        },
        // Nomes invertidos por causa de regra de negócio
        {
          field: "dataCarregamento",
          headerName: t("common.expectedDeliveryDate"),
          width: 200,
          editable: false,
          align: "center",
          headerAlign: "center",
          renderCell: (params: GridRenderCellParams) => {
            return (
              <div className="MuiDataGrid-cellContent">
                {params.value ? dateFormat(params.value) : ""}
              </div>
            );
          },
        },
        {
          field: "dataEntrega",
          headerName: t("common.loadingDate"),
          width: 200,
          editable: false,
          align: "center",
          headerAlign: "center",
          renderCell: (params: GridRenderCellParams) => {
            return (
              <div className="MuiDataGrid-cellContent">
                {params.value ? dateFormat(params.value) : ""}
              </div>
            );
          },
        },
        {
          field: "skuDescricao",
          headerName: t("common.skuIdDelivery"),
          minWidth: 300,
          flex: 2,
          editable: false,
          align: "center",
          headerAlign: "center",
          renderCell: (params) => <SkuDescricao value={params.value} />,
        },
        {
          field: "quantidadeEntregue",
          headerName: t("common.quantity"),
          width: 120,
          editable: false,
          align: "center",
          headerAlign: "center",
          type: "number",
          valueFormatter: (params) => round3(params.value) + " Kg",
        },
        {
          field: "paletizacao",
          headerName: t("common.palletizing"),
          width: 120,
          editable: false,
          align: "center",
          headerAlign: "center",
          type: "number",
          valueFormatter: (params) => round3(params.value),
        },
        {
          field: "grupoAmarracao",
          headerName: t("common.loading"),
          align: "center",
          headerAlign: "center",
          width: 150,
          editable: false,
          valueFormatter: (params) =>
            params.value ? `G - ${params.value}` : "",
        },
        {
          field: "origem",
          headerName: t("common.origin"),
          minWidth: 100,
          flex: 1,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "centroOrigem",
          headerName: t("common.originCenter"),
          width: 100,
          editable: step === 2,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "centroOrigemDescricaoLabel",
          headerName: t("common.originCenter"),
          width: 200,
          editable: false,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "depositoOrigem",
          headerName: t("common.originDeposit"),
          width: 150,
          editable: step === 2,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "centroDestino",
          headerName: t("common.destinationCenter"),
          width: 100,
          editable: step === 2,
          align: "center",
          headerAlign: "center",
        },
        step === 2
          ? {
              field: "centroDestinoDescricao",
              headerName: t("common.destinationCenter"),
              width: 200,
              sortable: false,
              editable: false,
              cellClassName: "MuiDataGrid-cell--editable",
              renderCell: (params: GridRenderCellParams) => {
                return <AutocompleteCentroProdutoAcabado {...params} />;
              },
            }
          : {
              field: "centroDestinoDescricaoLabel",
              headerName: t("common.destinationCenter"),
              width: 200,
              editable: false,
              align: "center",
              headerAlign: "center",
            },
        {
          field: "depositoDestino",
          headerName: t("common.destinationDeposit"),
          width: 150,
          editable: step === 2,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "contratoSap",
          headerName: t("common.contractSap"),
          width: 150,
          align: "center",
          headerAlign: "center",
        },
      ];
    }

    return cols;
  };

  function dateFormat(date: Date): string {
    return date.toLocaleDateString("pt-BR");
  }

  function montaCentroDescricao(centro: string): string {
    if (dataSetCentro.hasCache()) {
      const centros: CentroDistribuicao[] = dataSetCentro.ListarFromCache();
      if (centros) {
        const centroFound: CentroDistribuicao | undefined = centros.find(
          (f) => f.centro === centro
        );
        if (centroFound) {
          return String(centroFound.centro) + " - " + centroFound.nome;
        }
      }
    }
    return "";
  }

  function round3(value: number) {
    return value ? stripZeros(value.toFixed(3)) : 0;
  }

  function stripZeros(str: string) {
    return parseFloat(str.replace(",", ".")).toString().replace(".", ",");
  }

  function createEntrega(
    id: number,
    criadoEm: Date,
    dataCarregamento: Date,
    dataEntrega: Date,
    idSkuEntregue: number,
    quantidadeEntregue: number,
    unidadeMedida: string,
    novo: boolean,
    centroOrigem: string,
    centroDestino: string,
    depositoOrigem: string,
    depositoDestino: string,
    step: number,
    fator: number,
    contratoSap: string,
    grupoAmarracao?: string,
    origem?: string,
    saldo = 0,
    skuDescricao?: string
  ): Data {
    const centroOrigemDescricao: string = centroOrigem
      ? montaCentroDescricao(centroOrigem)
      : "";
    const centroDestinoDescricao: string = centroDestino
      ? montaCentroDescricao(centroDestino)
      : "";
    return {
      id,
      criadoEm,
      dataCarregamento,
      dataEntrega,
      idSkuEntregue,
      quantidadeEntregue,
      unidadeMedida,
      novo,
      skuDescricao,
      centroOrigem,
      centroDestino,
      centroOrigemDescricao,
      centroDestinoDescricao,
      depositoOrigem,
      depositoDestino,
      centroOrigemDescricaoLabel: centroOrigemDescricao,
      centroDestinoDescricaoLabel: centroDestinoDescricao,
      step,
      paletizacao: calculatePaletizacao(fator, quantidadeEntregue),
      quantidadeDePaletes: calculatePaletizacao(fator, quantidadeEntregue),
      contratoSap,
      grupoAmarracao,
      origem,
      saldo,
    };
  }

  const calculateQuantidade = (fator: number, qtdePaletes: number) => {
    return fator && fator > 0 && qtdePaletes && qtdePaletes > 0
      ? qtdePaletes * fator
      : 0;
  };

  const calculatePaletizacao = (fator: number, quantidade: number) => {
    return fator && fator > 0 && quantidade && quantidade > 0
      ? quantidade / fator
      : 0;
  };

  const checkBalance = React.useCallback(() => {
    return rows.filter(
      (item) =>
        (Number(item.quantidadeEntregue) || 0) > (Number(item.saldo) || 0)
    );
  }, [rows]);

  const showWarningInconsistenceBalance = (items: Data[]) => {
    setShowInconsistenteWarning(false);
    const singular = items.length === 1;
    const word = {
      item: `${singular ? t("common.item") : t("common.items")}`,
      esta: `${singular ? t("common.itIs") : t("common.are")}`,
      Item: `${singular ? t("common.item") : t("common.items")}`,
    };
    const _ = word;
    return confirmAlert({
      title: t("pages.finishiedProduct.text.inconsistencyInReportedBalance"),
      message: `${t("pages.finishiedProduct.text.have")} ${items.length} ${
        _.item
      } ${t("pages.finishiedProduct.text.that")} ${_.esta} ${t(
        "pages.finishiedProduct.text.exceedingBalance"
      )}. ${_.Item}: ${items.map((item) => item.skuDescricao).join(" | ")}. ${t(
        "pages.finishiedProduct.text.wantProceed"
      )}`,
      buttons: [
        {
          label: t("common.yes"),
          onClick: async () => {
            // aprovarProdutos();
            setShowApproveModal(true);
          },
        },
        {
          label: t("common.no"),
          onClick: () => {
            // setOpen(false);
          },
        },
      ],
    });
  };

  const handleSelectDatCarregamento = (titulo: string, mensagem: string) => {
    return confirmAlert({
      title: titulo,
      message: mensagem,
      willUnmount: () => {},
      customUI: ({ onClose }) => {
        return (
          <CustomAlertStep1
            onClickYes={(value: Date) => {
              setDatCarregamento(value);

              let balance = checkBalance();
              balance = balance.filter((x) =>
                idsSelecionados.find((y) => y == x.id)
              );

              if (balance.length === 0) {
                setShowApproveModal(true);
              } else {
                setShowInconsistenteWarning(true);
              }
            }}
            onClose={onClose}
          />
        );
      },
    });
  };

  const addDays = (date: Date, days: number) => {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };

  const handleSelectDatPrevistaEntregaECentroDestino = (
    titulo: string,
    mensagem: string
  ) => {
    return confirmAlert({
      title: titulo,
      message: mensagem,
      willUnmount: () => {},
      customUI: ({ onClose }) => {
        let datPrevistaEntregaDefault = new Date();
        let produtoAcabado = produtosAcabados.find(
          (x) => x.id == idsSelecionados[0]
        );
        if (produtoAcabado) {
          let datPrevEnt = new Date(produtoAcabado.dataPrevistaEntrega);
          datPrevistaEntregaDefault = addDays(datPrevEnt, 2);

          if (datPrevistaEntregaDefault.getDay() == 0) {
            datPrevistaEntregaDefault = addDays(datPrevistaEntregaDefault, 1);
          } else if (datPrevEnt.getDay() == 6) {
            datPrevistaEntregaDefault = addDays(datPrevistaEntregaDefault, 2);
          }
        }

        return (
          <CustomAlertStep2
            datPrevistaEntregaDefault={datPrevistaEntregaDefault}
            onClickYes={(
              datPrevistaEntrega: Date,
              centroDestino: number,
              depositoDestino?: string
            ) => {
              setDatPrevistaEntrega(datPrevistaEntrega);
              setCentroDestino(centroDestino);
              setDepositoDestino(depositoDestino ?? "");

              const balance = checkBalance();
              if (balance.length === 0) {
                setShowApproveModal(true);
              } else {
                setShowInconsistenteWarning(true);
              }
            }}
            onClose={onClose}
          />
        );
      },
    });
  };

  const handleConfimation = (titulo: string, mensagem: string) => {
    return confirmAlert({
      title: titulo,
      message: mensagem,
      willUnmount: () => {},
      buttons: [
        {
          label: t("common.yes"),
          onClick: async () => {
            // this lib doesnt support multiple popup;;
            const balance = checkBalance();
            if (balance.length === 0) {
              // if all right
              // aprovarProdutos();
              setShowApproveModal(true);
            } else {
              setShowInconsistenteWarning(true);
            }
          },
        },
        {
          label: t("common.no"),
          onClick: () => {
            // setOpen(false);
          },
        },
      ],
    });
  };

  function validarItensObrigatorios(data: Data): string | null {
    if (!data.centroOrigem) {
      return t("pages.finishiedProduct.text.informOriginCenter");
    }
    if (!data.centroDestino) {
      return t("pages.finishiedProduct.text.informDestinyCenter");
    }
    if (!data.depositoOrigem && data.centroOrigem !== "305") {
      return t("pages.finishiedProduct.text.informOriginDeposit");
    }
    if (!data.contratoSap || data.contratoSap.length < 1) {
      return t("pages.finishiedProduct.text.informContractSap");
    }
    return null;
  }

  function validarDataCriacao(data: Data): string | null {
    const tempDataAtual = zerarHoraMinutoSegundo(new Date());
    if (data.dataEntrega < tempDataAtual) {
      return t("pages.finishiedProduct.text.deliveryDateCannotBeEarlier");
    }
    return null;
  }

  function validarDatas(data: Data): string | null {
    const tempCriadoEm = zerarHoraMinutoSegundo(data.criadoEm);
    if (data.dataEntrega < tempCriadoEm) {
      return t("pages.finishiedProduct.text.deliveryDateCannotBeBefor");
    }
    return null;
  }

  function zerarHoraMinutoSegundo(date: Date) {
    const newDate = clonarDate(date);
    newDate.setHours(0);
    newDate.setMinutes(0);
    newDate.setSeconds(0);
    newDate.setMilliseconds(0);
    return newDate;
  }

  function clonarDate(date: Date) {
    return new Date(date.getTime());
  }

  const aprovarProdutos = () => {
    setLoading(true);
    const produtosAcabadosSelecionados: ProdutoAcabado[] =
      produtosAcabados.filter((f) => idsSelecionados.includes(f.id as number));
    if (!!produtosAcabadosSelecionados.length) {
      let erro = null;
      for (const produtoAcabado of produtosAcabadosSelecionados) {
        const data = rows.find((row) => row.id === produtoAcabado.id);
        produtoAcabado.step = step;
        // produtoAcabado.stepForward = new Date();
        produtoAcabado.aprovadoParceiro = step % 2 === 1;
        produtoAcabado.aprovadoBRF = step % 2 === 0;
        if (data) {
          if (!data.quantidadeEntregue || data.quantidadeEntregue < 1) {
            erro = t("pages.finishiedProduct.text.quantityMoreThanZero");
            break;
          }
          if (step <= 2) {
            if (!data.dataCarregamento) {
              erro = t("pages.finishiedProduct.text.requiredLoadDate");
              break;
            }
            erro = validarDataCriacao(data);
            if (erro) {
              break;
            }

            if (!data.origem) {
              erro = t("pages.finishiedProduct.text.originDontInformed");
              break;
            }
          }
          if (step === 2) {
            if (datPrevistaEntrega) data.dataCarregamento = datPrevistaEntrega;
            else {
              erro = t("pages.finishiedProduct.text.deliveryDateNeedInformed");
              break;
            }

            if (centroDestino ?? 0 > 0) data.centroDestino = centroDestino + "";
            else {
              erro = t("pages.finishiedProduct.text.requiredDestinyCenter");
              break;
            }

            data.depositoDestino = depositoDestino;

            erro = validarItensObrigatorios(data);
          }
          if (erro) {
            break;
          }
          if (step <= 2) {
            if (data.dataCarregamento) {
              produtoAcabado.dataCarregamento = data.dataCarregamento;
            }
            if (data.quantidadeEntregue) {
              produtoAcabado.quantidade = Number(data.quantidadeEntregue);
            }
            if (data.dataEntrega) {
              produtoAcabado.dataPrevistaEntrega = data.dataEntrega;
            }
            if (data.origem) {
              produtoAcabado.origem = data.origem;
            }
            if (data.contratoSap) {
              produtoAcabado.contratoSap = data.contratoSap;
            }

            if (step === 2) {
              produtoAcabado.centroOrigem = data.centroOrigem;
              produtoAcabado.centroDestino = data.centroDestino;
              produtoAcabado.depositoOrigem = data.depositoOrigem;
              produtoAcabado.depositoDestino = data.depositoDestino;
              produtoAcabado.contratoSap = data.contratoSap;
            }
          }

          if (step == 1) {
            if (!datCarregamento) {
              erro = t("pages.finishiedProduct.text.loadingDateMustBeFilled");
              break;
            }

            if (data.dataEntrega) {
              produtoAcabado.dataPrevistaEntrega = datCarregamento;
            }
          }
        }
      }

      if (erro) {
        setLoading(false);
        Mensagem(t("common.error"), erro, false);
      } else if (step >= 2) {
        integrarProdutos(produtosAcabadosSelecionados);
      } else if (step <= 1) {
        let agrupadoPorCarregamento =
          produtosAcabadosSelecionados.reduce(function (r, a) {
            let key = `${a.dataPrevistaEntrega}`;
            r[key] = r[key] || [];
            r[key].push(a);
            return r;
          }, Object.create(null)) ?? [];
        let paletizacaoValida = true;
        Object.keys(agrupadoPorCarregamento).forEach((key) => {
          let produtos = agrupadoPorCarregamento[key];
          let totalPalets = produtos.reduce(
            (accumulator: number, currentValue: any) =>
              accumulator + currentValue.quantidade / currentValue.fator,
            0
          );
          paletizacaoValida = validatePaletizacao(totalPalets);
        });

        if (paletizacaoValida) {
          integrarProdutos(produtosAcabadosSelecionados);
        } else {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    }
  };

  function integrarProdutos(produtosAcabadosSelecionados: ProdutoAcabado[]) {
    dataSet
      .Atualizar(produtosAcabadosSelecionados)
      .then((result) => {
        // PageHelper.refreshPage();
        setLoading(false);
        if (result) {
          Mensagem(
            t("common.warning"),
            idsSelecionados.length > 1
              ? t("pages.finishiedProduct.text.thePlural") +
                  idsSelecionados.length +
                  t("pages.finishiedProduct.text.itemsUpdatedSuccessfully")
              : `${t(
                  "pages.finishiedProduct.text.itemUpdatedSuccessfully"
                )} \n\r`
          );
          // setOpenSuccess(true);
        } else {
          Mensagem(
            t("common.error"),
            idsSelecionados.length > 1
              ? t("pages.finishiedProduct.text.thePlural") +
                  idsSelecionados.length +
                  t("pages.finishiedProduct.text.itemsProcessedWithProblems")
              : `${t(
                  "pages.finishiedProduct.text.itemProcessedWithProblems"
                )} \n\r`
          );
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }

  function validatePaletizacao(somaQtdes: number): boolean {
    if (!validatePaletizacaoMinima(somaQtdes)) {
      const msgErro =
        t("pages.finishiedProduct.text.totalQuantityReported") +
        round3(somaQtdes) +
        `) ${t("pages.finishiedProduct.text.isLess")} (` +
        paletizacaoMinima +
        `)!`;
      Mensagem(t("common.error"), msgErro, false);
      return false;
    }
    if (!validatePaletizacaoMaxima(somaQtdes)) {
      const msgErro =
        t("pages.finishiedProduct.text.totalQuantityReported") +
        round3(somaQtdes) +
        `) ${t("pages.finishiedProduct.text.isGreater")} (` +
        paletizacaoMaxima +
        `)!`;
      Mensagem(t("common.error"), msgErro, false);
      return false;
    }
    return true;
  }

  function validatePaletizacaoMinima(somaQtdes: number) {
    return Math.round(somaQtdes) >= paletizacaoMinima;
  }

  function validatePaletizacaoMaxima(somaQtdes: number) {
    return Math.floor(somaQtdes) <= paletizacaoMaxima;
  }

  function handleSelectionChange(ids: GridSelectionModel) {
    setIdsSelecionados(ids);
  }

  const onCellEditCommit = (
    params: GridCellEditCommitParams,
    _event: MuiEvent<MuiBaseEvent>
  ) => {
    if (params.field == "origem") {
      setRows((previousState) => {
        const tempRows = previousState as any;
        const rowIndex = previousState.findIndex((row) => row.id === params.id);

        if (rowIndex >= 0) {
          const row = previousState[rowIndex] as any;

          if (params.field in row && row[params.field] !== origem) {
            tempRows[rowIndex][params.field] = origem;

            let origemObj = origens.find((x) => x.origem == origem);
            if (origemObj) {
              console.log(origemObj);
              tempRows[rowIndex]["contratoSap"] = origemObj.contratoSap;
            }

            dataSet.AtualizarOrigem(+params.id, origem);
          }
        }
        return [...tempRows];
      });
    } else {
      setRows((prev) =>
        produce(prev, (draft) => {
          const actualRow = draft.find((row) => row.id === params.id);

          if (
            actualRow &&
            params.field in actualRow &&
            actualRow[params.field as keyof Data] !== params.value
          ) {
            (actualRow[params.field as keyof Data] as
              | string
              | number
              | boolean
              | Date
              | undefined) = params.value as
              | string
              | number
              | boolean
              | Date
              | undefined;

            if (
              [
                enumData.quantidadeDePaletes,
                enumData.quantidadeEntregue,
              ].includes(params.field as keyof Data)
            ) {
              const produtoAcabado = produtosAcabados.find(
                (product) => product.id === params.id
              );
              if (produtoAcabado) {
                if (params.field === enumData.quantidadeDePaletes) {
                  actualRow[enumData.quantidadeEntregue] = calculateQuantidade(
                    produtoAcabado.fator,
                    params.value
                  );
                } else if (params.field === enumData.quantidadeEntregue) {
                  actualRow[enumData.quantidadeDePaletes] =
                    calculatePaletizacao(
                      produtoAcabado.fator,
                      actualRow[enumData.quantidadeEntregue]
                    );
                }
              }
            }
          }
        })
      );
    }
  };

  useEffect(() => {
    if (produtosAcabados) {
      const dataArray: Data[] = produtosAcabados.map((item: ProdutoAcabado) => {
        const dataAtual = new Date();
        const criadoEm = new Date(item.criadoEm);

        const dataCarregamento =
          step > 1 ? new Date(item.dataCarregamento) : new Date();
        // const dataCarregamento =  item.dataCarregamento ? new Date(item.dataCarregamento) : new Date();

        const dataPrevistaEntrega = new Date(item.dataPrevistaEntrega);
        return createEntrega(
          Number(item.id),
          step === 1 && criadoEm < dataAtual ? dataAtual : criadoEm,
          dataCarregamento,
          step === 1 && dataPrevistaEntrega < dataAtual
            ? dataAtual
            : dataPrevistaEntrega,
          Number(item.idSku),
          Number(item.quantidade),
          String(item.unidadeMedida),
          false,
          String(item.centroOrigem),
          String(item.centroDestino),
          String(item.depositoOrigem),
          String(item.depositoDestino),
          Number(item.step),
          item.fator,
          String(item.contratoSap),
          item.grupoAmarracao,
          item.origem,
          item.saldo,
          item.skuDescricao
        );
      });
      setRows(dataArray);
    }
  }, [produtosAcabados]);

  const [activeStep, setActiveStep] = useState(step - 1);
  const [skipped, setSkipped] = useState(new Set<number>());

  useEffect(() => {
    if (step) {
      setActiveStep(step - 1);
      //MontaColunas();
      if (codigoFornecedorSap > 0 && numeroContrato && step) {
        dataSet
          .ListarAtivosPorContratoStep(
            codigoFornecedorSap,
            numeroContrato,
            step
          )
          .then((result) => {
            setProdutosAcabados(result);
          });
      }
    }
  }, [step]);

  const isStepOptional = (step: number) => {
    return step === 500;
  };

  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
    let _step = activeStep + 2;
    _step = _step > 4 || _step < 0 ? (_step = 1) : _step;
    window.location.href = PageHelper.urlClean() + "?step=" + String(_step);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    let _step = activeStep;
    _step = _step > 4 || _step < 0 ? (_step = 1) : _step;
    window.location.href = PageHelper.urlClean() + "?step=" + String(_step);
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const Mensagem = (
    titulo: string,
    mensagem: string,
    refresh: boolean = true
  ) => {
    return confirmAlert({
      title: titulo,
      message: mensagem,
      buttons: [
        {
          label: t("common.ok"),
          onClick: () => {
            // setOpen(false);
            if (refresh) {
              PageHelper.refreshPage();
            }
          },
        },
      ],
    });
  };

  const salvarLista = () => {
    setLoading(true);
    const produtosAcabadosSelecionados: ProdutoAcabado[] =
      produtosAcabados.filter((f) => idsSelecionados.includes(f.id as number));
    if (
      produtosAcabadosSelecionados &&
      produtosAcabadosSelecionados.length > 0
    ) {
      let erro = null;
      for (const produtoAcabado of produtosAcabadosSelecionados) {
        const data: Data | undefined = rows.find(
          (f) => f.id === produtoAcabado.id
        );
        produtoAcabado.step = step;
        if (data) {
          if (!data.quantidadeEntregue || data.quantidadeEntregue < 1) {
            erro = t("pages.finishiedProduct.text.quantityMoreThanZero");
            break;
          }
          if (step === 1 || step === 2) {
            erro = validarDatas(data);
          }
          if (erro) {
            break;
          }
          if (step === 1 || step === 2) {
            if (data.quantidadeEntregue) {
              produtoAcabado.quantidade = Number(data.quantidadeEntregue);
            }
            if (data.dataEntrega) {
              produtoAcabado.dataPrevistaEntrega = data.dataEntrega;
            }
            if (step === 1) {
              produtoAcabado.grupoAmarracao = data.grupoAmarracao;
            }
            if (step === 2) {
              produtoAcabado.dataCarregamento = data.dataCarregamento;
              produtoAcabado.centroOrigem = data.centroOrigem;
              produtoAcabado.centroDestino = data.centroDestino;
              produtoAcabado.depositoOrigem = data.depositoOrigem;
              produtoAcabado.depositoDestino = data.depositoDestino;
              produtoAcabado.contratoSap = data.contratoSap;
            }
          }
        }
      }

      if (erro) {
        setLoading(false);
        Mensagem(t("common.error"), erro, false);
      } else {
        dataSet
          .Atualizar(produtosAcabadosSelecionados)
          .then((result) => {
            // PageHelper.refreshPage();
            setLoading(false);
            if (result) {
              Mensagem(
                t("common.warning"),
                idsSelecionados.length > 1
                  ? t("pages.finishiedProduct.text.thePlural") +
                      idsSelecionados.length +
                      t("pages.finishiedProduct.text.itemsUpdatedSuccessfully")
                  : `${t(
                      "pages.finishiedProduct.text.itemUpdatedSuccessfully"
                    )} \n\r`
              );
            } else {
              Mensagem(
                t("common.error"),
                idsSelecionados.length > 1
                  ? t("pages.finishiedProduct.text.thePlural") +
                      idsSelecionados.length +
                      t(
                        "pages.finishiedProduct.text.itemsProcessedWithProblems"
                      )
                  : `${t(
                      "pages.finishiedProduct.text.itemProcessedWithProblems"
                    )} \n\r`
              );
            }
          })
          .catch((error) => {
            console.log(error);
            setLoading(false);
          });
      }
    }
  };

  function handleClickEstornar() {
    const produtosSelecionados: ProdutoAcabado[] = produtosAcabados.filter(
      (f) => idsSelecionados.includes(f.id as number)
    );
    if (produtosSelecionados && produtosSelecionados.length > 0) {
      dataSet.Estornar(step - 1, produtosSelecionados).then((result) => {
        if (result) {
          Mensagem(
            t("common.warning"),
            `${t("pages.finishiedProduct.text.thePlural")} ${t(
              "pages.finishiedProduct.text.itemsUpdatedSuccessfully"
            )} \n\r`
          );
        } else {
          Mensagem(
            t("common.error"),
            `${t("pages.finishiedProduct.text.thePlural")} ${t(
              "pages.finishiedProduct.text.itemsProcessedWithProblems"
            )} \n\r`
          );
        }
      });
    }
  }

  useEffect(() => {
    if (showInconsistenceWarning) {
      showWarningInconsistenceBalance(checkBalance());
    }
  }, [showInconsistenceWarning, checkBalance]);

  useEffect(() => {
    if (showApproveModal) {
      setShowApproveModal(false);
      aprovarProdutos();
    }
  }, [showApproveModal, aprovarProdutos]);

  const handleValidarSaldo = () => {
    if (bloqueiaSaldoNegativo) {
      let excededItems = checkBalance();
      excededItems = excededItems.filter((x) =>
        idsSelecionados.find((y) => y == x.id)
      );

      if (excededItems.length > 0) {
        let msg =
          excededItems.length > 1
            ? t("pages.finishiedProduct.text.itemsWithInsufficientBalance")
            : t("pages.finishiedProduct.text.itemWithInsufficientBalance");
        Mensagem(
          t("pages.finishiedProduct.text.insufficientBalance"),
          msg,
          false
        );
        return;
      }
    }

    handleSelectDatCarregamento(
      t("common.warning"),
      t("pages.finishiedProduct.text.wantProceed2")
    );
  };

  return (
    <div className={`container ${styles.container}`}>
      <div className="containerTitle">
        <TopoProdutoAcabado />
      </div>
      <div className={`containerToolbar`}>
        {/* <div className="">
          <FormControl>
            <InputLabel id="loadGroud">Amarração de carregamento</InputLabel>
            <Select
              labelId="loadGroud"
              id="loadGroud"
              // value={centroVirtual}
              // label={param.label}
              // onChange={handleChange}
              size="small"
            >
              <MenuItem value={"none"}></MenuItem>
              {Utils.generateHex(255).map(item => (
                <MenuItem key={item} value={item}>{item}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </div> */}
        {step === 2 ? (
          <Tooltip title={t("pages.finishiedProduct.text.cancelSelectedOrder")}>
            <span>
              <IconButton
                onClick={handleClickEstornar}
                disabled={!hasIdSelecionado || loading}
              >
                <DeleteForeverIcon />
              </IconButton>
            </span>
          </Tooltip>
        ) : null}

        {step === 3 ? (
          <Tooltip title={t("pages.finishiedProduct.text.moveSelectedOrder")}>
            <span>
              <IconButton
                onClick={handleClickEstornar}
                disabled={!hasIdSelecionado || loading}
              >
                <ReplayIcon />
              </IconButton>
            </span>
          </Tooltip>
        ) : null}

        <React.Fragment>
          {step === 2 ? (
            <Tooltip title={t("pages.finishiedProduct.text.saveChanges")}>
              <span>
                <IconButton
                  onClick={salvarLista}
                  disabled={!hasIdSelecionado || loading || user.isSuporte}
                >
                  <SaveIcon />
                </IconButton>
              </span>
            </Tooltip>
          ) : null}
        </React.Fragment>
        <React.Fragment>
          {step < 4 &&
          ((step == 1 && user.isPlanejamento) ||
            user.isPlanejamentoBRF ||
            user.isRoot) ? (
            <Tooltip title={t("pages.finishiedProduct.text.goToNextStep")}>
              <span>
                <IconButton
                  onClick={() =>
                    step == 1
                      ? handleValidarSaldo()
                      : step == 2
                      ? handleSelectDatPrevistaEntregaECentroDestino(
                          t("common.warning"),
                          t("pages.finishiedProduct.text.wantProceed2")
                        )
                      : handleConfimation(
                          t("common.warning"),
                          t("pages.finishiedProduct.text.wantProceed2")
                        )
                  }
                  disabled={!hasIdSelecionado || loading || user.isSuporte}
                >
                  <Send />
                </IconButton>
              </span>
            </Tooltip>
          ) : null}
        </React.Fragment>
      </div>
      <br />
      <div className={`divFlow ${styles.table}`}>
        <div className={styles.table}>
          <DataGrid
            loading={loading}
            rows={rows}
            columns={getColumns()}
            columnVisibilityModel={{
              centroDestino: false,
            }}
            rowsPerPageOptions={[50, 100, 250, 500]}
            checkboxSelection={
              (user.isRoot || user.isPlanejamento) && step <= 3
            }
            disableSelectionOnClick
            onSelectionModelChange={(ids) => {
              handleSelectionChange(ids);
            }}
            onRowClick={(x: any) => setIdLinhaSelecionada(x.id)}
            onCellEditCommit={onCellEditCommit}
            components={{
              NoRowsOverlay: () => (
                <Stack
                  height="100%"
                  alignItems="center"
                  justifyContent="center"
                >
                  {t("common.noResults")}
                </Stack>
              ),
            }}
          />
        </div>
      </div>
      {user.isRoot && (
        <div className="divFlow">
          <br />
          <br />
          <Box sx={{ width: "98%", backgroundColor: "transparent" }}>
            <Stepper activeStep={activeStep}>
              {steps.map((label, index) => {
                const stepProps: { completed?: boolean } = {};
                const labelProps: {
                  optional?: React.ReactNode;
                } = {};
                if (isStepOptional(index)) {
                  labelProps.optional = (
                    <Typography variant="caption">
                      {t("pages.dailyForecast.text.optional")}
                    </Typography>
                  );
                }
                if (isStepSkipped(index)) {
                  stepProps.completed = false;
                }
                return (
                  <Step key={label} {...stepProps}>
                    <StepLabel {...labelProps}>{label}</StepLabel>
                  </Step>
                );
              })}
            </Stepper>
            {activeStep === steps.length ? (
              <React.Fragment>
                <Typography sx={{ mt: 1, mb: 1, fontSize: "small" }}>
                  {t("pages.dailyForecast.text.allStepsCompleted")}
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                  <Box sx={{ flex: "1 1 auto" }} />
                  <Button onClick={handleReset}>Resetar</Button>
                </Box>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Typography sx={{ mt: 1, mb: 1, fontSize: "small" }}>
                  {t("common.step")} {activeStep + 1}
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "row", pt: 1 }}>
                  <Button
                    color="inherit"
                    disabled={
                      activeStep === 0 || (!user.isRoot && !user.isSuporteBRF)
                    }
                    onClick={handleBack}
                    sx={{ mr: 1 }}
                  >
                    {t("common.back")}
                  </Button>
                  <Box sx={{ flex: "1 1 auto" }} />
                  {isStepOptional(activeStep) && (
                    <Button
                      color="inherit"
                      onClick={handleSkip}
                      sx={{ mr: 1 }}
                      disabled
                    >
                      {t("global.button.skip")}
                    </Button>
                  )}
                  <Button
                    onClick={handleNext}
                    disabled={!user.isRoot && !user.isSuporteBRF}
                  >
                    {activeStep === steps.length - 1
                      ? t("common.finish")
                      : t("common.next")}
                  </Button>
                </Box>
              </React.Fragment>
            )}
          </Box>

          {/* {step === 1 && (
            <div className={styles.loadgroup}>
              <Grid container className={styles['loadgroup-header']}>
                <Grid item xs={6}>
                  <Typography>Grupos de amarração:</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography>Total de palets:</Typography>
                </Grid>
              </Grid>
              <Grid container className={styles['loadgroup-content']}>
                {Object.entries(loadGroup)?.map(([key, obj]) => (
                  <React.Fragment key={key}>
                    <Grid item xs={6} className={styles['loadgroup-content_item']}>
                      <Typography>{obj.name}</Typography>
                    </Grid>
                    <Grid item xs={6} className={styles['loadgroup-content_item']}>
                      <Typography>{obj.total}</Typography>
                    </Grid>
                  </React.Fragment>
                ))}
              </Grid>
            </div>
          )} */}
        </div>
      )}
      <Snackbar
        open={openSuccess}
        autoHideDuration={6000}
        onClose={() => setOpenSuccess(false)}
      >
        <Alert onClose={() => setOpenSuccess(false)} severity="success">
          {t("pages.finishiedProduct.text.itemApproveSuccessfully")}
        </Alert>
      </Snackbar>
    </div>
  );
}
